import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import Preloader from '../../../components/common/Preloader';
import {
  getEventCompetition,
  getEventDate,
  getEventHalfTimeResult,
  getEventTimeOrPeriod,
  isLoading,
  makeGetEventAway,
  makeGetEventHome,
  makeGetEventScoreAway,
  makeGetEventScoreHome,
  makeGetEventStartTime,
  makeIsEventInPlay
} from '../../../modules/events/selectors';
import { LIVE_SCORES } from '../../../routes/paths';
import { Tab, Tabs } from '../../common/Tabs';
import FormMessage from '../../FormMessage';
import { detailsViewEnter, detailsViewLeave } from '../actions';
import KeyEvents from '../KeyEvents';
import MatchStats from '../MatchStats';

export class EventDetails extends React.Component {
  componentDidMount() {
    const { match: { params: { day, eventId } } } = this.props;

    this.props.viewEnter(Number(day), eventId);
  }

  componentWillUnmount() {
    this.props.viewLeave();
  }

  render() {
    const {
      history,
      loading,
      competitionName,
      eventHome,
      eventAway,
      eventDate,
      eventStartTime,
      eventTimeOrPeriod,
      scoreHome,
      scoreAway,
      eventHalfTimeResult,
      isInPlay,
      match: { url, params: { eventId } }
    } = this.props;

    if (loading) {
      return (
        <div className="livescores-event-details">
          <div className="livescores-event-details__main">
            <div className="livescores-event-details__preloader">
              <Preloader>Loading events...</Preloader>
            </div>
          </div>
        </div>
      );
    }

    const isPreMatch = !isInPlay && scoreHome === '' && scoreAway === '';
    const isPostMatch = !isInPlay && !isPreMatch;
    const timeClasses = classnames('livescores-event-details__time',
      {
        'livescores-event-details__time--prematch': isPreMatch,
        'livescores-event-details__time--inplay': isInPlay,
        'livescores-event-details__time--postmatch': isPostMatch
      }
    );

    const tabContentHeader = (
      <FormMessage className="livescores-event-details__message" slotId="live_events" />
    );

    const tabContentFooter = (
      <div className="livescores-event-details__section">
        <Button
          onClick={() => history.push(LIVE_SCORES)}
          className="button--wide livescores-event-details__button"
        >
          <i className="material-icon material-icon--arrow-back" /> Go Back
        </Button>
      </div>
    );

    return (
      <div className="livescores-event-details">
        <div className="livescores-event-details__summary">
          <div className="livescores-event-details__scores">
            <div className="livescores-event-details__score">
              <div className="livescores-event-details__score-value">{scoreHome || '-'}</div>
              <div className="livescores-event-details__score-name">{eventHome}</div>
            </div>
            <div className="livescores-event-details__common">
              <div className={timeClasses}>{eventTimeOrPeriod || eventStartTime}</div>
              {eventHalfTimeResult && (
                <div className="livescores-event-details__extra-score">
                  HT: {eventHalfTimeResult.home} - {eventHalfTimeResult.away}
                </div>
              )}
            </div>
            <div className="livescores-event-details__score">
              <div className="livescores-event-details__score-value">{scoreAway || '-'}</div>
              <div className="livescores-event-details__score-name">{eventAway}</div>
            </div>
          </div>
          <div className="livescores-event-details__competition">
            {eventDate}, {competitionName}
          </div>
        </div>
        <Tabs className="tabs--dark livescores-event-details__tabs">
          <Tab url={url} label="Key Events">
            <div className="container--fixed">
              {tabContentHeader}
              <div className="livescores-event-details__section">
                <KeyEvents eventId={eventId} />
              </div>
              {tabContentFooter}
            </div>
          </Tab>
          <Tab url={`${url}/stats`} label="Match Stats">
            <div className="container--fixed">
              {tabContentHeader}
              <div className="livescores-event-details__section">
                <MatchStats eventId={eventId} />
              </div>
              {tabContentFooter}
            </div>
          </Tab>
        </Tabs>
      </div>
    );
  }
}

EventDetails.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  viewEnter: PropTypes.func.isRequired,
  viewLeave: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  competitionName: PropTypes.string,
  eventHome: PropTypes.string,
  eventAway: PropTypes.string,
  eventDate: PropTypes.string,
  eventStartTime: PropTypes.string,
  eventTimeOrPeriod: PropTypes.string,
  scoreHome: PropTypes.string,
  scoreAway: PropTypes.string,
  eventHalfTimeResult: PropTypes.object,
  isInPlay: PropTypes.bool
};

const mapStateToProps = (state, props) => {
  const { match: { params: { eventId } } } = props;
  const getEventHome = makeGetEventHome();
  const getEventAway = makeGetEventAway();
  const getEventStartTime = makeGetEventStartTime();
  const isEventInPlay = makeIsEventInPlay();
  const getEventScoreHome = makeGetEventScoreHome();
  const getEventScoreAway = makeGetEventScoreAway();
  return {
    loading: isLoading(state),
    eventHome: getEventHome(state, { eventId }),
    eventAway: getEventAway(state, { eventId }),
    eventStartTime: getEventStartTime(state, { eventId }),
    isInPlay: isEventInPlay(state, { eventId }),
    scoreHome: getEventScoreHome(state, { eventId }),
    scoreAway: getEventScoreAway(state, { eventId }),
    eventTimeOrPeriod: getEventTimeOrPeriod(state, { eventId }),
    eventDate: getEventDate(state, { eventId }),
    competitionName: getEventCompetition(state, { eventId }),
    eventHalfTimeResult: getEventHalfTimeResult(state, { eventId })
  };
};

const mapDispatchToProps = {
  viewEnter: detailsViewEnter,
  viewLeave: detailsViewLeave
};

export default connect(mapStateToProps, mapDispatchToProps)(EventDetails);
